/* eslint-disable */
const yxxnstate = {
	namespaced: true,
	state: {
		name: 'yxxnstate',
		htmltype: 'monitor',
		htmllx: 'XNYJ',
        currentMonth: '01', // 当前月，0表示当前选择的是年
        currentYear: '2018',
        CONST_UNIT: {
		    'FDL': '亿千瓦时',
		    'LYXSS': '小时',
		    'QDL': '亿千瓦时',
		    'QDLV': '%',
		    'ZJYD': '万千瓦',
		    'LYLV': '%'
		},
		indicator: 'FDL',
		category: 'XNY',
		selectedIndicators: ['XNJC', 'XNJC_XNY', 'XNJC_XNY_FDL'],
		yearormonth: 'N',
		indicators: [
			{ label: '发电量', value: 'FDL' },
			{ label: '弃电量', value: 'QDL' },
	        { label: '利用率', value: 'QDLV' }

		],
		xnjcindicators1: [
			{ label: '发电量', value: 'FDL' },
			{ label: '弃电量', value: 'QDL' },
	        { label: '利用率', value: 'QDLV' }
		],
		xnjcindicators2: [
			{ label: '发电量', value: 'FDL' },
	        { label: '利用小时数', value: 'LYXSS' },
	        { label: '弃风量', value: 'QDL' },
	        { label: '风电利用率', value: 'QDLV' }
		],
		xnjcindicators3: [
			{ label: '发电量', value: 'FDL' },
	        { label: '利用小时数', value: 'LYXSS' },
	        { label: '弃光量', value: 'QDL' },
	        { label: '光伏利用率', value: 'QDLV' }
		],

		yjindicators: [
	        { label: '利用率', value: 'QDLV' },
	        { label: '剩余空间', value: 'ZJYD' }
		],
		yjindicators1: [
			{ label: '利用率', value: 'QDLV' },
	        { label: '剩余空间', value: 'ZJYD' }
		],
		yjindicators2: [
			{ label: '风电利用率', value: 'QDLV' },
	        { label: '剩余空间', value: 'ZJYD' }
		],
		yjindicators3: [
			{ label: '光伏利用率', value: 'QDLV' },
	        { label: '剩余空间', value: 'ZJYD' }
		],
		legends: [

		],
		zjydStyle: {

		},
		areaStyle: {},
		timeStyle: {},
		areaContainerStyle: {},
		timeContainerStyle: {}
	},
	actions: {

	},
	mutations: {
		setCurrentMonth (state, val) {
			state.currentMonth = val
		}
	}
}
export default yxxnstate



// WEBPACK FOOTER //
// ./src/store/modules/yxxnstate.js